// extracted by mini-css-extract-plugin
export default {"typeTest":"TypeTest_typeTest__XKxfC","typeTest_imgTitle":"TypeTest_typeTest_imgTitle__Pvw2S","p":"TypeTest_p__TB961"};